import React, { useState } from 'react';

// Small icon-only copy button. Shows a check briefly after copying.
const CopyButton = ({ text, title = 'Copy', size = 14 }) => {
  const [done, setDone] = useState(false);

  const copy = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (!text) return;
    try { navigator.clipboard.writeText(String(text)); } catch { /* ignore */ }
    setDone(true);
    setTimeout(() => setDone(false), 1200);
  };

  return (
    <button type="button" className={`copy-btn ${done ? 'copied' : ''}`} onClick={copy} title={title} aria-label={title}>
      {done ? (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
      ) : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
      )}
    </button>
  );
};

export default CopyButton;
